module.exports = __webpack_public_path__ + "img/wood-house-garden.85828d7a.jpg";